import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { Transaction } from '@types';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import metamaskSlice from 'slices/metamaskSlice';
import { create } from 'zustand';

import UIReducer from '../slices/UISlice';
import modalSlice from '../slices/modalSlice';
import networkReducer from '../slices/networkSlice';
import walletReducer from '../slices/walletSlice';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['wallet', 'modals', 'networks']
};

const walletPersistConfig = {
  key: 'wallet',
  storage,
  whitelist: ['forceReconnect']
};

const networkPersistConfig = {
  key: 'networks',
  storage,
  whitelist: ['activeNetwork']
};

const reducers = combineReducers({
  wallet: persistReducer(walletPersistConfig, walletReducer),
  networks: persistReducer(networkPersistConfig, networkReducer),
  modals: modalSlice,
  UI: UIReducer,
  metamask: metamaskSlice
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk]
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

interface TransactionStore {
  transactions: Transaction[];
  setTransactions: (transactions: Transaction[]) => void;
  loading?: boolean;
}

export const useTransactionStore = create<TransactionStore>((set) => ({
  transactions: [],
  setTransactions: (transactions) => set({ transactions })
}));
